import React, { useState } from "react";
import "../../index.css";

export default function SchoolInfo() {
  const [form, setForm] = useState({
    schoolName: "",
    address1: "",
    address2: "",
    phone: "",
    mobile: "",
    email: "",
    website: "",
  });

  const [errors, setErrors] = useState({});

  // 🔹 Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value });

    // remove error while typing
    setErrors({ ...errors, [name]: "" });
  };

  // 🔹 Validation Function
  const validate = () => {
    let newErrors = {};

    if (!form.schoolName.trim()) {
      newErrors.schoolName = "School name is required";
    }

    if (!form.address1.trim()) {
      newErrors.address1 = "Address Line 1 is required";
    }

    if (!form.address2.trim()) {
      newErrors.address2 = "Address Line 2 is required";
    }

    if (!form.phone.trim()) {
      newErrors.phone = "Phone is required";
    }

    // ✅ Mobile Validation 
    if (!form.mobile) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(form.mobile)) {
      newErrors.mobile = "Mobile must be exactly 10 digits";
    }

    // ✅ Email Validation
    if (!form.email) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(form.email)) {
      newErrors.email = "Invalid email format";
    }

    // ✅ Website (optional but validate if entered)
    if (form.website && !/^https?:\/\/.+\..+/.test(form.website)) {
      newErrors.website = "Enter valid website (https://...)";
    }

    return newErrors;
  };

  // 🔹 Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    console.log("Form Submitted:", form);
    alert("Saved Successfully ✅");
  };

  return (
    <>
      <style>{`
        .page {
          background: #f4f6fb;
          min-height: 100vh;
        }

        .card {
          max-width: 1400px;
          margin: auto;
          background: #fff;
          border-radius: 10px;
          padding: 45px 50px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
        }

        .header {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 30px;
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
        }

        .full {
          grid-column: span 2;
        }

        .field {
          display: flex;
          flex-direction: column;
        }

        .field label {
          font-size: 13px;
          margin-bottom: 6px;
        }

        .field input {
          padding: 12px;
          border-radius: 6px;
          border: 1px solid #cbd5e1;
          font-size: 14px;
        }

        .field input.error {
          border-color: red;
        }

        .error-text {
          color: red;
          font-size: 12px;
          margin-top: 4px;
        }

        .actions {
          margin-top: 30px;
          display: flex;
          justify-content: flex-end;
        }

        .btn {
          background: #2563eb;
          color: white;
          border: none;
          padding: 12px 22px;
          border-radius: 6px;
          cursor: pointer;
        }
      `}</style>

      <div className="page">
        <div className="card">
          <div className="header">School Information</div>

          <form onSubmit={handleSubmit}>
            <div className="grid">

              {/* School Name */}
              <div className="field">
                <label>School Name</label>
                <input
                  type="text"
                  name="schoolName"
                  value={form.schoolName}
                  onChange={handleChange}
                  className={errors.schoolName ? "error" : ""}
                />
                {errors.schoolName && <span className="error-text">{errors.schoolName}</span>}
              </div>

              {/* Address 1 */}
              <div className="field">
                <label>Address Line 1</label>
                <input
                  type="text"
                  name="address1"
                  value={form.address1}
                  onChange={handleChange}
                  className={errors.address1 ? "error" : ""}
                />
                {errors.address1 && <span className="error-text">{errors.address1}</span>}
              </div>

              {/* Address 2 */}
              <div className="field">
                <label>Address Line 2</label>
                <input
                  type="text"
                  name="address2"
                  value={form.address2}
                  onChange={handleChange}
                  className={errors.address2 ? "error" : ""}
                />
                {errors.address2 && <span className="error-text">{errors.address2}</span>}
              </div>

              {/* Phone */}
              <div className="field">
                <label>Phone</label>
                <input
                  type="text"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  className={errors.phone ? "error" : ""}
                />
                {errors.phone && <span className="error-text">{errors.phone}</span>}
              </div>

              {/* Mobile */}
              <div className="field">
                <label>Mobile</label>
                <input
                  type="text"
                  name="mobile"
                  value={form.mobile}
                  onChange={handleChange}
                  className={errors.mobile ? "error" : ""}
                />
                {errors.mobile && <span className="error-text">{errors.mobile}</span>}
              </div>

              {/* Email */}
              <div className="field">
                <label>Email</label>
                <input
                  type="text"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className={errors.email ? "error" : ""}
                />
                {errors.email && <span className="error-text">{errors.email}</span>}
              </div>

              {/* Website */}
              <div className="field">
                <label>Website</label>
                <input
                  type="text"
                  name="website"
                  value={form.website}
                  onChange={handleChange}
                  className={errors.website ? "error" : ""}
                />
                {errors.website && <span className="error-text">{errors.website}</span>}
              </div>

            </div>

            <div className="actions">
              <button className="btn">Save Information</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}